module.exports = __webpack_public_path__ + "media/images/flags/16/Barbados-cffe2ea75ba7d578abcba7907d7b27e1.png";